export default "__VITE_ASSET__B5tx7bNE__"